<template>
  <div class="text-input">
    <img class="text-input-icon" :src="require('@/assets/games/zoom.svg')" alt="">
    <input
      v-model="inputValue"
      type="text"
      @input="$emit('typing', inputValue)"
      :placeholder="placeholder"
    >
    <v-icon class="clear-icon" @click="clear" v-if="inputValue">close</v-icon>
  </div>
</template>

<script>
export default {
  name: 'TextInput',
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    inputValue: '',
  }),
  mounted() {
    this.inputValue = this.value;
  },
  methods: {
    clear() {
      this.inputValue = '';
      this.$emit('typing', this.inputValue);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/_breakpoints.scss";

.text-input {
  position: relative;
  input {
    width: 100%;
    height: 50px;
    background: #FFFFFF;
    border: 2px solid #D1D1D1;
    border-radius: 25px;
    outline: none;
    padding: 5px 20px;
    font-size: 18px;
    transition: 0.5s;
    color: #000;

    @include for-size(small-tablets-only-or-landscape) {
      height: 40px;
      background: #FFFFFF;
      box-shadow: -2px -2px 2px rgba(0, 0, 0, 0.05), 2px 2px 2px rgba(0, 0, 0, 0.05);
      border-radius: 10px;
      border: none;
      padding: 5px 16px 5px 50px;
    }

    &:focus {
      border-color: #929eaa;
    }
    &::placeholder {
      color: #9F9F9F;
    }
  }

  &-icon {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    height: 28px;
    display: none;

    @include for-size(small-tablets-only-or-landscape) {
      display: block;
    }
  }

  .clear-icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 10px;
  }
}
</style>
